"use strict";
exports.__esModule = true;
exports.GENERIC_ERROR_MODAL_CONTENT = void 0;
exports.GENERIC_ERROR_MODAL_CONTENT = {
    TITLE: 'Something went wrong',
    SUBTITLE: 'We’re having issues processing your request. You can try again in a few moments. If the problem persists, reach out to our support team.'
};
